module.exports = __webpack_public_path__ + "img/redditicon.bac50d39.png";